import React, { Suspense, useContext } from "react"
import { ENTITY_TYPE } from 'common/constants';
import { Outlet, Route, Routes } from "react-router"
import ErrorTemplateFoundPage from "../common/ErrorTemplatePage"
import intl from 'components/i18n/ReactIntlWrapper'
import { AuthContext } from "components/authentication/context/authContext";
import ROUTES, { RoutePermissionDefinition } from "Routes";
import { DashboardLayout } from "layouts/dashboard";
import Spinner from "../Spinner";

export default function SecurityWrapperRoutes() {
    const { userEntityDetails, functionalities } = useContext(AuthContext);
    const entityType = userEntityDetails?.entityType;
    const userScopeSet = new Set(userEntityDetails?.scopes?.map(s => s.scope) ?? []);
    const functionalitySet = new Set(functionalities?.map(f => f.identifier) ?? []);

    return (
        <Routes>
            {ROUTES.map((route) => {
                const { scopes, identifier, entityTypes, ...routeProps } = route as RoutePermissionDefinition;

                const scopeGranted = identifier
                    ? functionalitySet.has(identifier)
                    : (scopes ? scopes.some(s => userScopeSet.has(s)) : true);

                const entityTypeGranted = !entityTypes ||
                    entityTypes.includes(ENTITY_TYPE.ANY) ||
                    entityTypes.includes(entityType as ENTITY_TYPE);

                const viewGranted = scopeGranted && entityTypeGranted;

                return (
                    <Route
                        key={routeProps.path}
                        element={viewGranted ?
                            <DashboardLayout>
                                <Suspense fallback={<Spinner />}>
                                    <Outlet />
                                </Suspense>
                            </DashboardLayout>
                        :
                            <ErrorTemplateFoundPage statusCode={401} title={intl.get('errorPage.unauthorized')} />
                        }
                    >
                        <Route {...routeProps} />
                    </Route>
                );
            })}
            <Route path="*" element={<ErrorTemplateFoundPage statusCode={404} title={intl.get('notFoundPage.title')} />} />
        </Routes>
    );
}
